// extracted by mini-css-extract-plugin
export var divider = "_10-0";
export var dividerText = "_10-1";